import React from 'react';
import Svg, { Path, Circle } from 'react-native-svg';
import { CustomSVGProps, getBaseSVGProps } from './utils';

const ProfileInfo: React.FC<CustomSVGProps> = (props) => {
    return (
        <Svg {...getBaseSVGProps(props, 60)} fill="none">
            <Path
                d="M45 41.632c0 3.98-1.62 6.492-4.206 8.067C38.129 51.322 34.347 52 30 52s-8.129-.678-10.794-2.3C16.62 48.123 15 45.611 15 41.631 15 33.572 21.694 27 30 27c8.306 0 15 6.573 15 14.632z"
                fill="#fff"
                stroke={props.color}
                strokeWidth={2}
            />
            <Circle cx={30} cy={18} r={10} fill="#fff" stroke={props.color} strokeWidth={2} />
        </Svg>
    );
};

export default React.memo(ProfileInfo);
